var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('Loading',{staticClass:"wrapper centered"}):_c(_vm.layout,{tag:"component",staticClass:"wrapper centered"})}
var staticRenderFns = []

export { render, staticRenderFns }